import React from "react";
import Card from "react-bootstrap/Card";


function StoryCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            Our journey began with a deep <span className="purple">yearning for truth</span> and <span className="purple">positive change</span>. We were inspired by the realization that,
            despite the tremendous advancements in technology, humanity still struggles with disparities and injustices.
            This sparked our commitment to create a meaningful impact—one that goes beyond technological development to address
            the challenges faced by individuals and society.
          </p>

          <p className="about-text">
            Our story draws inspiration from the ancient Persian myth of the Simorgh, a mythical bird that symbolizes the journey
            of <span className="purple">self-discovery</span> and <span className="purple">transformation</span>. In the tale, a group of birds sets out on a long, arduous quest to find the legendary
            Simorgh. Along the way, they face countless obstacles, endure hardships, and are forced to confront their deepest fears and
            limitations. Ultimately, when they reach their destination, they discover that the Simorgh was not a distant, external
            entity—but a reflection of themselves. Through struggle and perseverance, they find their true nature and purpose.

          </p>

          <p className="about-text">
            In much the same way, we embarked on a journey to be actively engaged in the <span className="purple">technological transformation of society</span>,
            both on the individual and collective levels. The path was not easy. It required patience, the removal of prejudices,
            and the courage to face the illusions that clouded our understanding of truth. The pursuit of truth became our guiding
            force, a process of deep introspection that allowed us to uncover not only the potential of technology but the true potential
            of humanity itself.

          </p>

          <p className="about-text">
            We believe that the search for truth is essential to realizing our true identity, much like the birds in the Simorgh myth
            who discovered that the answers they sought had been within them all along. In this process of seeking, we are reminded
            that every human is endowed with <span className="purple">invaluable capacities</span>—capacities that come to fruition through guidance, support, and,
            above all, love. An unbiased love for humanity, and a deep passion for its progress, allows us to transcend superficial
            differences and reach the core reality of what it means to be human. This love enables us to break through dysfunctional
            patterns, to overcome the impossible, and to tap into the collective potential for positive change.

          </p> 
          
          <p className="about-text">
            As we continue our journey, we remain committed to helping others discover their true selves—empowering individuals to
            transform their lives and contribute to a more just, innovative, and connected world. Just as the birds found that the
            Simorgh was within them, we believe that the <span className="purple">true power of technology lies within us all</span>, waiting to be nurtured and
            harnessed for the greater good.
          </p>

          <p className="about-text">
            We are driven by the knowledge that the path to true technological advancement is one that serves humanity, that seeks the truth,
            and that ultimately reveals the boundless potential we all share.
          </p>

        
          
          <footer className="blockquote-footer"></footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default StoryCard;
